<div *ngIf="loading" class="loading">
  <div style="display: flex; justify-content: center; flex: 1">
    <!-- <img id="loader" src="assets/img/patientlynk/SVG/icon.svg"> -->
    <img class="patientlynk_updater_index" id="loader" src="../../../assets/patientlynk/img/SVG/icon.svg">
  </div>
</div>

<app-intro-section [type]="'generic'"></app-intro-section>

<div class="br-tr br-br login-form">
  <h2 [innerHTML]="'login_message_header' | transloco">Access your Healthcare Data anywhere, anytime.</h2>

  <app-login-form></app-login-form>

  <div class="">

    <div class="orDivider my-5">
      <span transloco="or">OR</span>      
    </div>

    <h2 class="mb-5" transloco="needAccount">Do you need an account?</h2>

    <div class="d-block">
      <button routerLink="/registration" class="ab_button adjusted white my-3 mx-auto" transloco="signUp">Sign Up</button>
    </div>
    <p>&nbsp;</p>

    <div *ngIf="(theme.name == 'MisResultados' || theme.name == 'LabInfo') && !isNative" class="play_container">
      <a [href]="theme.play_container.app_store" target="_blank"><img class="play_links" src="/assets/common/img/PNG/app_store.png" alt=""></a>
      <a [href]="theme.play_container.play_store" target="_blank"><img class="play_links" src="/assets/common/img/PNG/play_store.png" alt=""></a>
    </div>

    <div *ngIf="!env?.debug" id="debug" class="mt-4">
      <div>ENV: {{env.name}}</div>
      <div>BUILD: {{env.build}}</div>
      <div *ngIf="env.update">
        <span>UPDATE AVAILABLE: </span>
        <a (click)="triggerSwUpdate()">Click to refresh.</a>
      </div>
    </div>
  </div>

  <!-- <span class="powered-by">
    <span *ngIf="!env?.showVersion" (dblclick)="env.showVersion = true">© Abartys Health, 2021. </span>
    <span *ngIf="env?.showVersion" (dblclick)="env.showVersion = false">
      {{env.name}}-v{{env.version}} –
    </span>
    <span class="text-nowrap non-abartys">
      <span transloco="poweredBy">Powered by</span>
      <em><b><span class="ab-green"> patient</span>Lynk</b></em>
    </span>
  </span> -->
</div>

<apps-banner style="flex: 1;"></apps-banner>